<template>
  <div id="ResultMessage">
    <div class="dim" v-if="GET_COMPLETE_MSG">
      <div class="window-box">
        <div class="result-message">
          <p>{{ $t('completed1') }}</p>
          <p>{{ $t('completed2') }}</p>
        </div>
        <button class="result-submit" @click="hideCompleteMessage">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex'
export default {
  computed: {
    ...vuex.mapGetters({
      'GET_COMPLETE_MSG': 'request/GET_COMPLETE_MSG'
    })
  },
  methods: {
    ...vuex.mapMutations({
      'SET_COMPLETE_MSG': 'request/SET_COMPLETE_MSG'
    }),
    hideCompleteMessage () {
      this.SET_COMPLETE_MSG(false)
      location.href = 'https://www.open-pay.co.kr';
    }
  }
}
</script>

<style lang="scss">
#ResultMessage {
  .dim {
    display: flex;
    justify-content: center;
    align-items: center;

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: rgba($color: #000000, $alpha: .8);

    .window-box {
      width: 300px;
      padding: 30px 30px 20px;

      border-radius: 30px;
      background-color: white;

      .result-message {
        // font-size: 20px;
        font-size: 17px;
        // font-weight: bold;

        text-align: center;
        line-height: 1.5;
      }

      .result-submit {
        display: inline-block;
        
        width: 100%;
        height: 50px;
        margin-top: 30px;

        border: solid 1px $color_a;
        border-radius: 25px;
        font-size: 17px;
        background-color: $color_a;
        color: white;

        &:active {
          background-color: $color_a_d;
        }
      }
    }
  }
}
</style>